import { ExerciceDto } from "../../dto/GenApi.iNotPaie.Dto/ExerciceDto";
import { FeatureFlagModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";
import { ParametrageModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/ParametrageModuleEnum";
import { ParametrageModuleIdEnum } from "../../dto/GenApi.iNotPaie.Dto/ParametrageModuleIdEnum";
import { ParametreModuleDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreModuleDto";
import { UtilisateurConnecteDto } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurConnecteDto";
import { EventBus } from "../Controls/EventBus";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { FeatureFlagManagerInstance } from "../Controls/FeatureFlagManager";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ModalEnqueteSatisfactionOptions } from "../modalComponents/modalEnqueteSatisfaction/modalEnqueteSatisfaction";

export class ServiceEnqueteDeSatisfaction {
    private lastExerciceClosed!: ExerciceDto;
    private userPst?: UtilisateurConnecteDto;
    private modePst?: ParametreModuleDto;
    private isSatisfactionRequired?: boolean;

    public enqueteDeSatisfaction(callbackYes?: () => void): void {
        this.userPst = ParametresInstance.utilisateurCourant;

        this.getModePst(() => {
            if (this.modePst?.StrData !== "1" || !this.isUserPst()) {
                callbackYes?.();
                return;
            }

            const hasSurvey = FeatureFlagManagerInstance.hasFeatureFlag(FeatureFlagModuleEnum.EnqueteSatisfactionPst);
            const hasSurveyOld = FeatureFlagManagerInstance.hasFeatureFlag(FeatureFlagModuleEnum.AncienneEnqueteSatisfactionPst);

            if (hasSurveyOld) {
                this.handleOldSurvey(callbackYes);
            } else if (hasSurvey) {
                this.handleNewSurvey(callbackYes);
            } else {
                callbackYes?.();
            }
        });
    }

    private handleOldSurvey(callbackYes?: () => void): void {
        this.getLastExerciceClosed(() => {
            if (this.lastExerciceClosed?.Note === null) {
                const modalOptions: ModalEnqueteSatisfactionOptions = new ModalEnqueteSatisfactionOptions({
                    message: "Avez-vous été satisfait du traitement de vos payes du mois passé?",
                    callbackYes: callbackYes,
                });
                EventBus.$emit(EventConstants.MODAL_ENQUETE_SATISFACTION, modalOptions);
            } else {
                callbackYes?.();
            }
        });
    }

    private handleNewSurvey(callbackYes?: () => void): void {
        this.getLastSatisfactionSurvey(() => {
            if (this.isSatisfactionRequired) {
                const modalOptions: ModalEnqueteSatisfactionOptions = new ModalEnqueteSatisfactionOptions({
                    callbackYes: callbackYes,
                });
                EventBus.$emit(EventConstants.MODAL_ENQUETE_SATISFACTION_PST, modalOptions);
            } else {
                callbackYes?.();
            }
        });
    }

    public getLastExerciceClosed(callback?: () => void): ExerciceDto {
        ServicesFactoryInstance.ExercicesService.getDernierExerciceCloture(data => {
            this.lastExerciceClosed = data;
            callback?.();
        });
        return this.lastExerciceClosed;
    }

    public getLastSatisfactionSurvey(callback?: () => void): boolean | undefined {
        const dernierExercice = ParametresInstance.societeCourante?.DernierExercice;

        if (!dernierExercice) {
            callback?.();
            return;
        }

        ServicesFactoryInstance.SatisfactionService.getIsSatisfactionSurveyRequired(data => {
            this.isSatisfactionRequired = data;
            callback?.();
        });

        return this.isSatisfactionRequired;
    }

    private getModePst(callback?: () => void): void {
        ServicesFactoryInstance.ParametrageModuleService.getParametrageModule(ParametrageModuleEnum.PST, ParametrageModuleIdEnum.PST_ACTIVE, data => {
            this.modePst = data;
            callback?.();
        });
    }

    private isUserPst(): boolean {
        return this.userPst?.Roles?.indexOf(RoleConstants.UtilisateurPST) !== -1;
    }

}

export const ServiceEnqueteDeSatisfactionInstance: ServiceEnqueteDeSatisfaction = new ServiceEnqueteDeSatisfaction();



// WEBPACK FOOTER //
// ./src/components/enqueteDeSatisfaction/service.ts